import { KioskResource } from './KioskResource';

export class FooterAndKioskResource{
    rid: number;
    kiosk: KioskResource;
}